import React from "react";
import PropTypes from "prop-types";
import { Badge } from "reactstrap";
import { LedgerConnectButton } from "@bkry/bowline-components/ConnectWalletButton";
import { FaExternalLinkAlt, FaInfoCircle } from "react-icons/fa";

const LedgerConnectInfo = (props, context) => {
  const { suggestedChainId } = props;
  return (
    <div className="text-center d-flex flex-column">
      <p className="h4 text-center fw-bold mb-5">
        {context.t("Connect with Ledger")}
        <Badge size="sm" color="secondary" className="ms-2">
          BETA
        </Badge>
      </p>
      <LedgerConnectButton
        closeConnectWallet={props.closeConnectWallet}
        suggestedChainId={suggestedChainId}
      />
      <p className="my-4">
        {context.t(
          "Ledger is a common and often used wallet that enables users to access the Web 3 ecosystem of decentralized applications."
        )}
      </p>
      <p className="mb-5">
        {context.t(
          "Once you click the Connect Button you can use Ledger Live and Ledger Connect from your Computer or Mobile Phone."
        )}
      </p>
      <p className="small text-start">
        <strong>{context.t("Want to learn more about this wallet?")}</strong>
        <br />
        {context.t("Learn how to install and setup this wallet on")}{" "}
        <a
          href="https://ledger.com/ledger-live"
          target="_blank"
          rel="noreferrer"
          className="mt-5"
        >
          ledger.com/ledger-live <FaExternalLinkAlt />
        </a>
        .
      </p>
      <p className="mt-5 small text-muted">
        <FaInfoCircle className="me-1" />
        {context.t(
          "We've just recently added support for this wallet. If you experience any issue please let us know."
        )}
      </p>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
LedgerConnectInfo.contextTypes = {
  t: PropTypes.func,
};

export default LedgerConnectInfo;
